import {useSelector} from 'react-redux';

import {buildDelaySelectOptions} from 'shared/ui/DelaySelector/DelaySelector';
import {getDelayLabel} from 'features/http/lib/notificationSettingsView';
import {userSelector} from 'entities/user';

export const useNotificationSettings = () => {
    const user = useSelector(userSelector);
    const delayOptions = buildDelaySelectOptions();

    return {
        email: user?.email,
        getDelayLabel: (delay?: number) => getDelayLabel(delay, delayOptions),
    };
};

export default useNotificationSettings;
